import React from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import Dialog from '@components/shared/Dialog'
import ExternalLink from '@components/shared/ExternalLink'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'

const AccessSoundCheckDialog: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Dialog name="access_soundcheck" maxWidth={400} title={t('content.accessSoundCheck')}>
      <DialogBody />
    </Dialog>
  )
}

const DialogBody: React.FC = () => {
  const { t } = useTranslation()
  const closeDialog = useDialogStore((s) => s.closeDialog)
  const session = useSession()

  // Admin
  if (session.isSiteAdmin()) {
    return (
      <>
        <p className="mb-3">{t('content.addSoundCheckDesc')}</p>
        <Button
          variant="primary"
          className="text-md px-2 py-1.5 float-right mt-2"
          onClick={() => {
            window.open('https://www.noteflight.com/commerce/purchase_learn', '_blank')
            closeDialog('access_soundcheck')
          }}>
          {t('action.purchaseSoundCheck')}
        </Button>
      </>
    )
  }

  // Teacher
  if (session.isSiteTeacher()) {
    return (
      <>
        <p className="mb-3">{t('content.addSoundCheckDesc')}</p>
        <p className="mb-3">
          <Trans i18nKey="content.addSoundCheckDesc_teacher">
            Talk to your site’s admin to add SoundCheck. If your site has SoundCheck, manage access
            in Manage Site &gt;
            <a
              title="addons"
              className="orange-link"
              href={`/groups#/group/${session.communityGroup?.id}/addons`}>
              Manage Add-Ons
            </a>
          </Trans>
        </p>
      </>
    )
  }

  // Student
  if (session.isSiteStudent()) {
    return <p className="mb-3">{t('content.addSoundCheckDesc', { context: 'student' })}</p>
  }

  // Default community
  if (session.isDefaultCommunity()) {
    return (
      <>
        <p className="mb-3">
          <span className="block">{t('content.addSoundCheckDesc')}</span>
          <ExternalLink
            title="learn more"
            href="/soundcheck"
            className="text-orange hover:underline">
            {t('action.learnMore')}
          </ExternalLink>
        </p>
        <Button
          variant="primary"
          className="text-md px-2 py-1.5 float-right mt-2"
          onClick={() => {
            window.open('/commerce/purchase_annual?sc=true', '_blank')
            closeDialog('access_soundcheck')
          }}>
          {t('action.purchaseSoundCheck')}
        </Button>
      </>
    )
  }

  return null
}

export default AccessSoundCheckDialog
